import { render, staticRenderFns } from "./detailSubprogram.vue?vue&type=template&id=1e92b7ac&scoped=true"
import script from "./detailSubprogram.vue?vue&type=script&lang=js"
export * from "./detailSubprogram.vue?vue&type=script&lang=js"
import style0 from "./detailSubprogram.vue?vue&type=style&index=0&id=1e92b7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e92b7ac",
  null
  
)

export default component.exports